import { render, staticRenderFns } from "./RecommendActivityTablePane.vue?vue&type=template&id=20e3f32a&scoped=true"
import script from "./RecommendActivityTablePane.vue?vue&type=script&lang=js"
export * from "./RecommendActivityTablePane.vue?vue&type=script&lang=js"
import style0 from "./RecommendActivityTablePane.vue?vue&type=style&index=0&id=20e3f32a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3f32a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e3f32a')) {
      api.createRecord('20e3f32a', component.options)
    } else {
      api.reload('20e3f32a', component.options)
    }
    module.hot.accept("./RecommendActivityTablePane.vue?vue&type=template&id=20e3f32a&scoped=true", function () {
      api.rerender('20e3f32a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/recommend_activity/RecommendActivityTablePane.vue"
export default component.exports